import moment from 'moment';
import { isValidLotSize } from 'oms-js-utils/lib/validation';

import {
  validateInstrument,
  validateLimit,
  validateVisible,
} from 'utils/validation/trade';
import * as FormUtils from 'utils/form';

export default function validate(values) {
  return {
    instrument: validateInstrument(values),
    volume: validateVolume(values),
    limit: validateLimit(values),
    visible: validateVisible(values),
    validity: validateValidity(values),
  };
}

function validateVolume({ volume, lotSizeRule }) {
  const normalizedVolume = FormUtils.normalizeNumber(volume);
  const isPositiveAndPresent = volume && normalizedVolume > 0;

  if (volume && !isValidLotSize(normalizedVolume, lotSizeRule)) {
    // Allow empty while we are loading lotSize
    if (!lotSizeRule) {
      return;
    }

    return `Antall: Lot Size er ${lotSizeRule.lotSize} for dette instrumentet`;
  }

  if (!isPositiveAndPresent) {
    return 'Volum er ikke gyldig heltall (kun heltall lovlig)';
  }
}

function validateValidity({ validity }) {
  // Present, and within time span of now <--> 45 days from now
  const date = moment(validity, 'x');
  const now = moment().startOf('day');
  const futureDate = moment()
    .add(45, 'days')
    .endOf('day');

  if (date.isBefore(now) || date.isAfter(futureDate)) {
    return 'Ugyldig dato';
  }
}
